import React, { useEffect, useState, useMemo } from 'react';
import {
  Col,
  Segment,
  Bubble,
  Icon,
} from 'tea-component';

import { useLocal } from '@/pages/dashboard/utils/customHook';
import SwitchChart from './SwitchChart';
import TrendPairRow from './TrendPairRow';
import { adjustedtabTypeSourceList, appannieTypeSourceList, TAB_NAME, GAME_DATE_TYPE_MAP } from '../../_config/constants';
import useColumns from '../../_config/columns';
import { getChartAndTableOpt, getTrendsChartData, getTrendsTableData, getTrendsDownloadData, getRetentionTrendsChartData, getRetentionTrendsTableData, getRetentionTrendsDownloadData } from '../../_config/KeyMetricsTrends';
import { competitorRequest } from '../../_config/competitorRequest';

const RANGE_DATE_KEY_MAP = {
  date: 'Day',
  week: 'Week',
  month: 'Month'
} as any;

const KeyMetricsTrend = (props: any) => {
  const { 
    filterValue, 
    filterLoading, 
    gameCode,
    competitorReqType,
    isCasual = false,
  } = props;
  const { isLaunchTime = false, isEarliestData = false, selector } = filterValue ?? {};
  const hasMonth = filterValue?.filterValue?.rangeTime?.type === 'month';
  const source = filterValue?.filterValue?.source;

  const { dauColumns, revenuColumns, newColumns, retentionColumns } = useColumns(hasMonth);
  const { locale, getLocalText } = useLocal();
  const trendDataInit = { chartData: [], tableData: [], downloadData: [] };
  const retentioonDataInit = { 'd2': trendDataInit, 'd3': trendDataInit, 'd7': trendDataInit, 'd15': trendDataInit, 'd31': trendDataInit };
  // dau trends
  const [dauData, setDauData] = useState<any>(trendDataInit);
  // Revenue Trends
  const [revenueData, setRevenueData] = useState<any>(trendDataInit);
  const [revenueType, setRevenueType] = useState<any>('revenue');
  // New Trends
  const [newData, setNewData] = useState<any>(trendDataInit);
  const [retentionData, setRetentionData] = useState<any>(retentioonDataInit);
  const [retentionType, setRetentionType] = useState<any>('d2');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  // const [retentionLoading, setRetentionLoading] = useState(true);
  // const [retentionError, setRetentionError] = useState(false);

  const updateData = () => {
    const {
      isLaunchTime = false,
      isEarliestData = false,
      filterValue: newFilterValue = {}
    } = filterValue ?? {};


    const {rangeTime, rangeDayMonth, region, system, source, competitor} = newFilterValue;
    
    const { type: launchTimeType, value: launchTime } = rangeDayMonth ?? {};
    const { type: timeType, value: rangeDate } = rangeTime ?? {};
    const params = {
      period: TAB_NAME[(isLaunchTime || isEarliestData) ? launchTimeType : RANGE_DATE_KEY_MAP[timeType]],
      game_code: gameCode,
      start_time: (isLaunchTime || isEarliestData) ? launchTime[0] : rangeDate[0],
      end_time: (isLaunchTime || isEarliestData) ? launchTime[1] : rangeDate[1],
      is_launch_time: isEarliestData ? false : isLaunchTime,
      is_earliest_time: isEarliestData,
      filters: {
        market_list: region.markets,
        os_list: system,
        competitor_list: competitor,
        source: source,
      },
    };

    setLoading(true);
    // setRetentionLoading(true);
    competitorRequest.getKeyMetricsTrendData[competitorReqType](params)
      .then((data) => {
        const resDauDataList = data?.dau_trends || [];
        const resRevenueDataList = data?.revenue_trends || [];
        const resAdjustedRevenueDataList = data?.adjusted_revenue_trends || [];
        const resNewDataList = data?.new_trends || [];
        const isDayOrWeek = params.period !== 'monthly';
        const competitorIdList = competitor?.map((item: any) => item?.unified_id) || [];

        setDauData({
          chartData: getTrendsChartData(competitorIdList, resDauDataList, isDayOrWeek, (isLaunchTime || isEarliestData)),
          tableData: getTrendsTableData(resDauDataList, isDayOrWeek, (isLaunchTime || isEarliestData), true) || [],
          downloadData: getTrendsDownloadData(resDauDataList, isDayOrWeek, (isLaunchTime || isEarliestData), true) || [],
        });
        
        // 切换成appannie数据源时，增加调整收入
        if (appannieTypeSourceList?.includes(source)) {
          if(source === 'sensortower') {
            setRevenueType('revenue');
          }
          setRevenueData({
            'revenue': {
              chartData: getTrendsChartData(competitorIdList, resRevenueDataList, isDayOrWeek, (isLaunchTime || isEarliestData)),
              tableData: getTrendsTableData(resRevenueDataList, isDayOrWeek, (isLaunchTime || isEarliestData)) || [],
              downloadData: getTrendsDownloadData(resRevenueDataList, isDayOrWeek, (isLaunchTime || isEarliestData)) || [],
            },
            'adjusted': {
              chartData: getTrendsChartData(competitorIdList, resAdjustedRevenueDataList, isDayOrWeek, (isLaunchTime || isEarliestData)),
              tableData: getTrendsTableData(resAdjustedRevenueDataList, isDayOrWeek, (isLaunchTime || isEarliestData)) || [],
              downloadData: getTrendsDownloadData(resAdjustedRevenueDataList, isDayOrWeek, (isLaunchTime || isEarliestData)) || []
            }
          });
        } else {
          setRevenueType('revenue');
          setRevenueData({
            chartData: getTrendsChartData(competitorIdList, resRevenueDataList, isDayOrWeek, (isLaunchTime || isEarliestData)),
            tableData: getTrendsTableData(resRevenueDataList, isDayOrWeek, (isLaunchTime || isEarliestData)) || [],
            downloadData: getTrendsDownloadData(resRevenueDataList, isDayOrWeek, (isLaunchTime || isEarliestData)) || []
          });
        }

        setNewData({
          chartData: getTrendsChartData(competitorIdList, resNewDataList, isDayOrWeek, (isLaunchTime || isEarliestData)),
          tableData: getTrendsTableData(resNewDataList, isDayOrWeek, (isLaunchTime || isEarliestData), true) || [],
          downloadData: getTrendsDownloadData(resNewDataList, isDayOrWeek, (isLaunchTime || isEarliestData), true) || []
        });
        setError(false);
      })
      .catch((err) => {
        console.log(err);
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });

    competitorRequest.getKeyMetricsTrendRetentionData[competitorReqType](params)
      .then((data) => {
        const resD2DataList = data?.avg_d2 || [];
        const resD3DataList = data?.avg_d3 || [];
        const resD7DataList = data?.avg_d7 || [];
        const resD15DataList = data?.avg_d15 || [];
        const resD31DataList = data?.avg_d31 || [];
        const { period } = params;
        const isDayOrWeek = period !== 'monthly';
        setRetentionData(
          {
            'd2': {
              chartData: getRetentionTrendsChartData(resD2DataList, isDayOrWeek),
              tableData: getRetentionTrendsTableData(resD2DataList, isDayOrWeek) || [],
              downloadData: getRetentionTrendsDownloadData(resD2DataList, isDayOrWeek) || [],
            },
            'd3': {
              chartData: getRetentionTrendsChartData(resD3DataList, isDayOrWeek),
              tableData: getRetentionTrendsTableData(resD3DataList, isDayOrWeek) || [],
              downloadData: getRetentionTrendsDownloadData(resD3DataList, isDayOrWeek) || [],
            },
            'd7': {
              chartData: getRetentionTrendsChartData(resD7DataList, isDayOrWeek),
              tableData: getRetentionTrendsTableData(resD7DataList, isDayOrWeek) || [],
              downloadData: getRetentionTrendsDownloadData(resD7DataList, isDayOrWeek) || []
            },
            'd15': {
              chartData: getRetentionTrendsChartData(resD15DataList, isDayOrWeek),
              tableData: getRetentionTrendsTableData(resD15DataList, isDayOrWeek) || [],
              downloadData: getRetentionTrendsDownloadData(resD15DataList, isDayOrWeek) || []
            },
            'd31': {
              chartData: getRetentionTrendsChartData(resD31DataList, isDayOrWeek),
              tableData: getRetentionTrendsTableData(resD31DataList, isDayOrWeek) || [],
              downloadData: getRetentionTrendsDownloadData(resD31DataList, isDayOrWeek) || []
            }
          }
        );
        // setRetentionError(false);
      })
      .catch((err) => {
        console.log(err);
        // setRetentionError(true);
      })
      .finally(() => {
        // setRetentionLoading(false);
      });
  };

  const DWM: any = {
    Day: getLocalText('competitor_key_metrics_dau_trend_title'),
    Week: getLocalText('competitor_key_metrics_wau_trend_title'),
    Month: getLocalText('competitor_key_metrics_mau_trend_title'),
    LaunchMonth: getLocalText('competitor_key_metrics_agv_dau_trend_title'),
  };

  // 根据时间类型展示DAU标题
  const getDAUTrendsTitle = useMemo(() => {
    // const { switchDatePicker, timeType, dayMonth } = filterValue ?? {}
    const {
      isLaunchTime = false,
      isEarliestData = false,
      filterValue: newFilterValue = {}
    } = filterValue ?? {};
    const {rangeTime, rangeDayMonth} = newFilterValue;
    const { type: launchTimeType } = rangeDayMonth ?? {};
    const { type: timeType } = rangeTime ?? {};
    // const { type: launchTimeType } = dayMonth ?? {}
    const title = (isLaunchTime || isEarliestData) ? launchTimeType === 'Month' ? DWM['LaunchMonth'] : DWM[launchTimeType] : DWM[RANGE_DATE_KEY_MAP[timeType]];
    const defaultDateType = GAME_DATE_TYPE_MAP[gameCode]?.defaultType || 'month';
    return title || DWM[RANGE_DATE_KEY_MAP[defaultDateType] || 'Month'];
  }, [filterValue, locale]);

  const dauOptions = useMemo(() => {
    // const { switchDatePicker, timeType, dayMonth } = filterValue ?? {}
    const {
      isLaunchTime = false,
      filterValue: newFilterValue = {}
    } = filterValue ?? {};
    const {rangeTime, rangeDayMonth} = newFilterValue;
    const { type: launchTimeType } = rangeDayMonth ?? {};
    const { type: timeType } = rangeTime ?? {};
    // const { type: launchTimeType } = dayMonth ?? {}

    const type: any = {
      Day: 'dau',
      Week: 'wau',
      Month: 'mau',
    };
    const launchType: any = {
      Day: 'dau',
      Month: 'avg_dau',
    };
    
    return getChartAndTableOpt(dauData, dauColumns(isLaunchTime ? launchType[launchTimeType] : type[RANGE_DATE_KEY_MAP[timeType]] || 'dau'));
  }, [dauData, locale]);

  const revenueOptions = useMemo(() => {
    // 处理表格表头
    if (appannieTypeSourceList?.includes(filterValue?.filterValue?.source)) {
      return getChartAndTableOpt(revenueData?.[revenueType], revenuColumns(revenueType));
    }
    return getChartAndTableOpt(revenueData, revenuColumns(revenueType));
  }, [revenueData, revenueType, filterValue, locale]);

  const newOptions = useMemo(() => {
    return getChartAndTableOpt(newData, newColumns);
  }, [newData, locale]);

  const retentionOptions = useMemo(() => {
    // 处理表格表头
    return getChartAndTableOpt(retentionData?.[retentionType], retentionColumns(retentionType));
  }, [retentionData, retentionType, locale]);

  useEffect(() => {
    if (filterLoading) return;
    updateData();
  }, [filterValue, filterLoading]);

  const timeType = RANGE_DATE_KEY_MAP[filterValue?.filterValue?.rangeTime?.type];

  const getRevenueTabList = useMemo(() => {
    return adjustedtabTypeSourceList?.includes(source)  ? [
      {
        text: getLocalText('competitor_key_metrics_revenue_trend_tab1'),
        value: 'revenue'
      },
      {
        text: getLocalText('competitor_key_metrics_revenue_trend_tab2'),
        value: 'adjusted'
      },
    ] : [ {
      text: getLocalText('competitor_key_metrics_revenue_trend_tab1'),
      value: 'revenue'
    },];
    
  }, [source, locale]);
  
  if (isCasual) {
    return (
      <>
        <Col span={12}>
          <SwitchChart
            title={getDAUTrendsTitle}
            timeType={timeType}
            loading={loading}
            isError={error}
            isNoData={dauOptions?.table?.data?.length === 0}
            chartOptions={dauOptions.chart}
            tableOptions={dauOptions.table}
            isInt={true}
            isLaunchTime={isLaunchTime}
            isEarliestData={isEarliestData}
            filterSelector={selector}
          />
        </Col>
        <Col span={12}>
          <SwitchChart
            title={getLocalText('competitor_key_metrics_new_trend_title')}
            timeType={timeType}
            loading={loading}
            isError={error}
            isNoData={newOptions?.table?.data?.length === 0}
            chartOptions={newOptions.chart}
            tableOptions={newOptions.table}
            isInt={true}
            isLaunchTime={isLaunchTime}
            isEarliestData={isEarliestData}
            filterSelector={selector}
          />
        </Col>
      </>
    );
  }

  return (
    <>
      <TrendPairRow
        locale={locale}
        left={syncedH => (
          <SwitchChart
            title={getDAUTrendsTitle}
            timeType={timeType}
            loading={loading}
            isError={error}
            isNoData={dauOptions?.table?.data?.length === 0}
            chartOptions={dauOptions.chart}
            tableOptions={dauOptions.table}
            isInt={true}
            isLaunchTime={isLaunchTime}
            isEarliestData={isEarliestData}
            filterSelector={selector}
            syncedToolbarHeight={syncedH}
          />
        )}
        right={toolbarRef => (
          <SwitchChart
            title={getLocalText('competitor_key_metrics_revenue_trend_title')}
            timeType={timeType}
            loading={loading}
            isError={error}
            isNoData={revenueOptions?.table?.data?.length === 0}
            chartOptions={revenueOptions.chart}
            tableOptions={revenueOptions.table}
            isLaunchTime={isLaunchTime}
            isEarliestData={isEarliestData}
            slotStripRef={toolbarRef}
            slot={
              <div>
                <Segment
                  className="dbd-keyMetrics-segment"
                  value={revenueType}
                  onChange={setRevenueType}
                  options={getRevenueTabList}
                />
                {revenueType === 'adjusted' && !loading && (
                  <Bubble
                    arrowPointAtCenter
                    dark={true}
                    placement="bottom-start"
                    content={
                      <div
                        dangerouslySetInnerHTML={{
                          __html: getLocalText(
                            'competitor_key_metrics_adjusted_revenue_desc',
                          ),
                        }}
                      />
                    }
                  >
                    <Icon
                      type="info"
                      style={{ verticalAlign: 'super', marginLeft: '5px' }}
                    />
                  </Bubble>
                )}
              </div>
            }
            filterSelector={selector}
          />
        )}
      />
      <TrendPairRow
        locale={locale}
        left={syncedH => (
          <SwitchChart
            title={getLocalText('competitor_key_metrics_new_trend_title')}
            timeType={timeType}
            loading={loading}
            isError={error}
            isNoData={newOptions?.table?.data?.length === 0}
            chartOptions={newOptions.chart}
            tableOptions={newOptions.table}
            isInt={true}
            isLaunchTime={isLaunchTime}
            isEarliestData={isEarliestData}
            filterSelector={selector}
            syncedToolbarHeight={syncedH}
          />
        )}
        right={toolbarRef => (
          <SwitchChart
            title={getLocalText('competitor_key_metrics_retention_trend_title')}
            timeType={timeType}
            loading={loading}
            isError={error}
            isNoData={retentionOptions?.table?.data?.length === 0}
            chartOptions={retentionOptions.chart}
            tableOptions={retentionOptions.table}
            isPercent={true}
            noDataText={getLocalText('competitor_key_metrics_retention_no_data')}
            slotStripRef={toolbarRef}
            slot={
              <Segment
                className="dbd-key-metrics-segment"
                value={retentionType}
                onChange={setRetentionType}
                options={[
                  {
                    text: getLocalText('competitor_key_metrics_performance_d2'),
                    value: 'd2',
                  },
                  {
                    text: getLocalText('competitor_key_metrics_performance_d3'),
                    value: 'd3',
                  },
                  {
                    text: getLocalText('competitor_key_metrics_performance_d7'),
                    value: 'd7',
                  },
                  {
                    text: getLocalText('competitor_key_metrics_performance_d15'),
                    value: 'd15',
                  },
                  {
                    text: getLocalText('competitor_key_metrics_performance_d31'),
                    value: 'd31',
                  },
                ]}
              />
            }
            isLaunchTime={isLaunchTime}
            isEarliestData={isEarliestData}
            filterSelector={selector}
          />
        )}
      />
    </>
  );
};

export default KeyMetricsTrend;
